<CardBase {element}>
  <div class="drop-countdown">
    {#if active}
      <div class="drop-countdown-text-area">
        <div class="drop-countdown-title">
          {title}
        </div>
        <div class="drop-countdown-description">
          {description}
        </div>
      </div>
      <div class="drop-countdown-clock">
        {#if showResultsButton}
          <div class="results-button-wrapper flex-center">
            <img alt="View Results" src={viewResultsImageUrl} class="results-button" on:click={showResultsClick}>
          </div>
        {:else}
          <div class="countdown-title sixties-scoreboard flex-center">Drop Will Occur At</div>
          <div class="countdown-digits sixties-scoreboard flex-center">
            <span class="minutes">{minutes.toString().padStart(2, '0')}</span>
            <span class="colon">:</span>
            <span class="seconds">{seconds.toString().padStart(2, '0')}</span>
          </div>
        {/if}
        <div class="countdown-entry-counter sixties-scoreboard flex-center">
          <span class="counter-label">&lt;&nbsp;</span>
          <span class="counter-number">{entryCount}</span>
          <span class="counter-label">&nbsp;In Drop &gt;</span>
        </div>
      </div>
    {:else}
      <div class="drop-inactive flex-center">
        No drop active! Check back later.
      </div>
    {/if}
  </div>
</CardBase>

<style>*, *:before, *:after {
  box-sizing:border-box;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.drop-countdown {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: gray;
}

.drop-inactive {
  width: 100%;
  height: 100%;
  flex: 1 0 100%;
  font-style: italic;
}

.drop-countdown-text-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-right: 10px;
}

.drop-countdown-title {
  font-weight: bold;
  font-size: 125%;
}

.drop-countdown-description {
}

.drop-countdown-clock {
  flex: 1;
}

.countdown-title {
  font-size: 80%;
}

.countdown-digits {
  font-size: 3rem;
  margin-top: -7px;
  margin-bottom: -4px;
}

.minutes {
  margin-right: -7px;
}

.seconds {
  margin-left: -7px;
}

.countdown-entry-counter {
  padding-bottom: 5px;
  font-size: 80%;
}

.counter-number {
}

.counter-label {
}

.results-button-wrapper {
  /*width: 90%;*/
}

.results-button {
  /*background-color: var(--f7-theme-primary);
    border: none;
    color: var(--f7-theme-color);
    padding: 1rem 1rem;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    */
  width: 90%;
}</style>

<script lang="ts">var _a;
import { YinzCamCardsServiceElement } from "yinzcam-cards";
import CardBase from "../../../common/CardBase.svelte";
import { findSourceStore } from "../../../utilities";
import { Readable } from "svelte/store";
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import { f7 } from 'framework7-svelte';
export let element;
export let sources;
export let sourceStore;
function redirectOnDecision() {
    if (won) {
        f7.views.main.router.navigate(`/cards/${data.WinPage}`);
    }
    else if (lost) {
        f7.views.main.router.navigate(`/cards/${data.LosePage}`);
    }
}
function showResultsClick() {
    redirectOnDecision();
}
$: {
    sourceStore = findSourceStore($sources, 'YinzCamDropsServerCurrentDrop');
}
;
$: data = (sourceStore && $sourceStore) ? $sourceStore : null;
$: active = (data === null || data === void 0 ? void 0 : data.Active) || false;
$: secondsLeft = (data === null || data === void 0 ? void 0 : data.SecondsLeft) || 0;
$: minutes = Math.min(999, Math.floor(secondsLeft / 60));
$: seconds = (secondsLeft >= 1000 * 60) ? 59 : secondsLeft % 60;
$: endTime = data === null || data === void 0 ? void 0 : data.EndTime;
$: title = (data === null || data === void 0 ? void 0 : data.CountdownTitle) || '';
$: description = (data === null || data === void 0 ? void 0 : data.CountdownDescription) || '';
$: won = (data === null || data === void 0 ? void 0 : data.Won) || false;
$: lost = (data === null || data === void 0 ? void 0 : data.Lost) || false;
$: dropDecided = won || lost;
// This sets up a reactive variable in a feedback loop that, once triggered, stays true even if the other variables change later.
// As long as the system starts off undecided, this will stay undecided for the lifetime of the page, so that we can auto redirect/
// If the system was always decided from the start then we want to show a button in place of the countdown clock.
$: dropWasUndecided = dropWasUndecided || (data && !dropDecided);
$: if (endTime && ((Date.now() - endTime) < 5 * 60 * 1000) && dropWasUndecided && dropDecided) {
    //alert(`Now: ${Date.now()} - EndTime: ${endTime} - Diff: ${Date.now() - endTime} - 5min: ${5*60*1000}`)
    redirectOnDecision();
}
// This is true if you come back to the page after the drop is decided (it's not decided while you're on the page).
$: showResultsButton = dropDecided && !dropWasUndecided;
$: entryCount = (data === null || data === void 0 ? void 0 : data.EntryCount) || 0;
$: viewResultsImageUrl = (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.viewResultsImageUrl;
</script>